import React from 'react';
import { Container, ContainerMes } from './styles';
import { Table } from '../../../shared/components/table';

interface IColunaGradeHoraria {
  nome: string;
  numero: number;
}

interface ILinhaGradeHoraria {
  horario: string;
  [key: number]: string;
}

interface Props {
  mes: string;
  colunas: IColunaGradeHoraria[];
  linhas: ILinhaGradeHoraria[];
}

const CalendarioHorarios: React.FC<Props> = (props) => {
  const data = React.useMemo(() => props.linhas, []);

  const columns = React.useMemo(
    () => [
      {
        Header: props.mes,
        columns: [
          {
            Header: 'Dia da Semana',
            columns: [
              {
                Header: 'Horário/Data',
                accessor: 'horario',
              },
            ],
          },
          ...props.colunas.map((c) => ({
            Header: c.nome,
            columns: [
              {
                Header: c.numero.toString(),
                accessor: c.numero.toString(),
              },
            ],
          })),
        ],
      },
    ],
    []
  );

  return (
    <Container>
      <ContainerMes>{props.mes}</ContainerMes>
      <Table
        data={data}
        columns={columns}
        getHeaderGroupProps={(headerGroup) => {
          const isMesRow = headerGroup.headers.some((col: any) => col.Header === props.mes);
          return { className: isMesRow ? 'row-mes-header' : undefined, 'data-header-type': isMesRow ? 'mes' : undefined } as any;
        }}
        getCellProps={(cellInfo) => ({
          className: cellInfo.value === 'FERIADO' ? 'feriado' : undefined,
        })}
      />
    </Container>
  );
};

export { CalendarioHorarios };
export type { IColunaGradeHoraria, ILinhaGradeHoraria };
